<template>
  <section id="info" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">招租公告其他事项</div>
      </a-space>
    </div>

    <a-descriptions bordered :column="1" class="fixed-13-desc">
      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">招租公告起始日期</span>
        </template>
        --
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">招租公告截止日期</span>
        </template>
        --
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">公告发布期（工作日）</span>
        </template>
        {{ intentLeaseInfo.disclosurePeriod }}
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text"> 招租公告发布期满未征集到意向方 </span>
        </template>
        {{
          intentLeaseInfo.disclosurePeriodExtend == 12
            ? `延长发布，不变更招租公告条件，按照 ${
                intentLeaseInfo.extendWorkingDays || "--"
              } 工作日为一个延长周期，延长 ${
                intentLeaseInfo.extendedCyclesNumber || "--"
              } 周期`
            : intentLeaseInfo.disclosurePeriodExtend == 14
            ? "变更招租公告内容，重新申请发布招租"
            : intentLeaseInfo.disclosurePeriodExtend == 11
            ? "招租公告发布终结"
            : "--"
        }}
      </a-descriptions-item>
    </a-descriptions>
  </section>
</template>

<script>
export default {
  props: {
    intentLeaseInfo: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}

.fixed-13-desc /deep/ .ant-descriptions-item-label {
  width: 25%;
}

.fixed-13-desc /deep/ .ant-descriptions-item-content {
  width: 75%;
  background: white;
}
</style>